import React from 'react';
import './Notification.css';

export default function Notification({ title, message, onClose, onClick }) {
    return (
        <div className='notification' onClick={onClick} role='button' tabIndex={0}>
      <div className='notification-body'>
        <strong>{title}</strong>
        <p>{message}</p>
      </div>
      <button
        className='notification-close'
        onClick={(e) => { e.stopPropagation(); onClose() }}
      >
        ✕
      </button>
    </div>
    );
}
